// constants
import { ProductsActionTypes } from "./constants";

//Action
export interface ProductsActionType {
  type:
    | ProductsActionTypes.GET_LIST_PRODUCTS_ERROR
    | ProductsActionTypes.GET_LIST_PRODUCTS_SUCCESS
    | ProductsActionTypes.GET_LIST_PRODUCTS
    | ProductsActionTypes.CREATE_PRODUCT
    | ProductsActionTypes.CREATE_PRODUCT_SUCCESS
    | ProductsActionTypes.CREATE_PRODUCT_ERROR
    | ProductsActionTypes.GET_PRODUCT
    | ProductsActionTypes.GET_PRODUCT_SUCCESS
    | ProductsActionTypes.GET_PRODUCT_ERROR
    | ProductsActionTypes.UPDATE_PRODUCT
    | ProductsActionTypes.UPDATE_PRODUCT_SUCCESS
    | ProductsActionTypes.UPDATE_PRODUCT_ERROR
    | ProductsActionTypes.DELETE_PRODUCT
    | ProductsActionTypes.DELETE_PRODUCT_SUCCESS
    | ProductsActionTypes.DELETE_PRODUCT_ERROR;
  payload: {} | string;
}

//Interfaces
interface ProductsData {
  iteam?: any[];
  total?: number;
  keyword?: string;
  limit?: number;
  skip?: number;
  owner?: string;
}

interface ProductCreate {
  name: string;
  price: number;
  description: string;
  quantity: number;
  comment: string;
  productImage: string;
}

interface ProductUpdate {
  name: string;
  price: number;
  description: string;
  quantity: number;
  comment: string;
  productImage: string;
}

interface GetProduct {
  id: string;
}

interface DeleteProduct {
  ids: string[];
}

//Product_List
export const productsGetListSuccess = (
  actionType: string,
  data: ProductsData | {}
): ProductsActionType => ({
  type: ProductsActionTypes.GET_LIST_PRODUCTS_SUCCESS,
  payload: { actionType, data },
});

export const productsGetListError = (
  actionType: string,
  error: string
): ProductsActionType => ({
  type: ProductsActionTypes.GET_LIST_PRODUCTS_ERROR,
  payload: { actionType, error },
});

export const getProductsList = (
  keyword: string = "",
  limit: number = 10,
  skip: number = 0,
  owner: string = "",
  country: string = "ic",
  mode: string = "",
  startDate?: string,
  endDate?: string
): ProductsActionType => ({
  type: ProductsActionTypes.GET_LIST_PRODUCTS,
  payload: { keyword, limit, skip, owner, country, mode, startDate, endDate },
});

//Create Product
export const createProductSuccess = (
  actionType: string,
  data: ProductCreate | {}
): ProductsActionType => ({
  type: ProductsActionTypes.CREATE_PRODUCT_SUCCESS,
  payload: { actionType, data },
});
export const createProductError = (
  actionType: string,
  error: string
): ProductsActionType => ({
  type: ProductsActionTypes.CREATE_PRODUCT_ERROR,
  payload: { actionType, error },
});
export const createProduct = (
  country: string,
  affiliate: string,
  name: string,
  price: number,
  description: string,
  quantity: number,
  comment: string,
  productImage: string
): ProductsActionType => ({
  type: ProductsActionTypes.CREATE_PRODUCT,
  payload: {
    country,
    affiliate,
    name,
    price,
    description,
    quantity,
    comment,
    productImage,
  },
});

//Update Product
export const updateProductSuccess = (
  actionType: string,
  data: ProductUpdate | {}
): ProductsActionType => ({
  type: ProductsActionTypes.UPDATE_PRODUCT_SUCCESS,
  payload: { actionType, data },
});
export const updateProductError = (
  actionType: string,
  error: string
): ProductsActionType => ({
  type: ProductsActionTypes.UPDATE_PRODUCT_ERROR,
  payload: { actionType, error },
});

export const updateProduct = (
  id: string,
  data: ProductUpdate
): ProductsActionType => ({
  type: ProductsActionTypes.UPDATE_PRODUCT,
  payload: { id, ...data },
});

//GET Product

export const getProductSuccess = (
  actionType: string,
  data: GetProduct | {}
): ProductsActionType => ({
  type: ProductsActionTypes.GET_PRODUCT_SUCCESS,
  payload: { actionType, data },
});
export const getProductError = (
  actionType: string,
  error: string
): ProductsActionType => ({
  type: ProductsActionTypes.GET_PRODUCT_ERROR,
  payload: { actionType, error },
});

export const getProduct = (id: string): ProductsActionType => ({
  type: ProductsActionTypes.GET_PRODUCT,
  payload: { id },
});

//DELETE Product

export const deleteProductSuccess = (
  actionType: string,
  data: DeleteProduct | {}
): ProductsActionType => ({
  type: ProductsActionTypes.DELETE_PRODUCT_SUCCESS,
  payload: { actionType, data },
});
export const deleteProductError = (
  actionType: string,
  error: string
): ProductsActionType => ({
  type: ProductsActionTypes.DELETE_PRODUCT_ERROR,
  payload: { actionType, error },
});

export const deleteProduct = (ids: string[]): ProductsActionType => ({
  type: ProductsActionTypes.DELETE_PRODUCT,
  payload: { ids },
});
